import './private-key-button.scss';
import React, { useCallback, useState } from 'react';
import { KeySelectionButton, KeySelectionModal } from 'components';

interface IPrivateKeyButton {
  onKeyChange: (key?: string) => void;
}

export default function PrivateKeyButton({ onKeyChange }: IPrivateKeyButton) {
  const [keySelectionModalOpen, setKeySelectionModalOpen] = useState(false);

  const [fileName, setFileName] = useState<string>();

  const onSubmitKey = useCallback(
    (privateKey: string, fileName: string) => {
      setKeySelectionModalOpen(false);
      setFileName(fileName);
      onKeyChange(privateKey);
    },
    [onKeyChange]
  );

  const onClearKey = useCallback(() => {
    setFileName(undefined);
    onKeyChange(undefined);
  }, []);

  return (
    <>
      <KeySelectionButton
        keyName={fileName}
        onClick={() => setKeySelectionModalOpen(true)}
        onClearKey={onClearKey}
      />
      <KeySelectionModal
        isOpen={keySelectionModalOpen}
        onClose={() => setKeySelectionModalOpen(false)}
        onSubmit={onSubmitKey}
      />
    </>
  );
}
